import { ausrehabApi as baseApi } from '../baseApi';
import type { SectionProps, SectionWithQuestionsProps } from './apis.types';

const sectionApi = baseApi.injectEndpoints({
	endpoints: (builder) => ({
		// List all standalone sections (without questions)
		getSections: builder.query<SectionProps[], void>({
			query: () => ({ url: 'sections' }),
			providesTags: ['Questionnaire'],
		}),

		// Get a single section with its questions
		getSectionWithQuestions: builder.query<SectionWithQuestionsProps, number>({
			query: (id) => ({ url: `sections/${id}` }),
			providesTags: ['Questionnaire'],
		}),

		// Create a new section (ADMIN)
		createSection: builder.mutation<SectionProps, { name: string; description?: string | null }>({
			query: (payload) => ({ url: 'sections', method: 'POST', body: payload }),
			invalidatesTags: ['Questionnaire'],
		}),

		// Update section name/description (ADMIN)
		updateSection: builder.mutation<SectionWithQuestionsProps, { id: number; name?: string; description?: string | null }>({
			query: ({ id, ...payload }) => ({ url: `sections/${id}`, method: 'PUT', body: payload }),
			invalidatesTags: ['Questionnaire'],
		}),

		// Delete a section (ADMIN) — blocked if questions are still assigned
		deleteSection: builder.mutation<{ deleted: boolean }, number>({
			query: (id) => ({ url: `sections/${id}`, method: 'DELETE' }),
			invalidatesTags: ['Questionnaire'],
		}),
	}),
	overrideExisting: false,
});

export const {
	useGetSectionsQuery,
	useGetSectionWithQuestionsQuery,
	useCreateSectionMutation,
	useUpdateSectionMutation,
	useDeleteSectionMutation,
} = sectionApi;
